import { styled, Box } from '@mui/material';

import theme from 'shared/styles/theme';

export const StyledAppletPasswordContainer = styled(Box)`
  padding: ${theme.spacing(0, 3.2)};
`;
